var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "item pb-3 mb-5 border-bottom",
      attrs: { id: "regional_service--" + _vm.element.id }
    },
    [
      _c(
        "transition",
        { attrs: { mode: "out-in", name: "slide" } },
        [
          !_vm.isEdit
            ? _c(
                "div",
                { staticClass: "row col-12" },
                [
                  _c("div", { staticClass: "col-12 col-md-4 text-center" }, [
                    _c("img", {
                      staticClass: "image mw-100",
                      attrs: { src: _vm.imagePath, alt: "" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-8" }, [
                    _c("div", { staticClass: "row d-flex h-100" }, [
                      _vm.element.name
                        ? _c("h2", {
                            staticClass: "col-12",
                            domProps: { innerHTML: _vm._s(_vm.element.name) }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.element.description
                        ? _c("div", {
                            staticClass: "col-12",
                            domProps: {
                              innerHTML: _vm._s(_vm.element.description)
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.element.file.length > 0 && _vm.element.file[0].url
                        ? _c(
                            "div",
                            { staticClass: "col-12 text-right align-self-end" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-outline-secondary btn-sm",
                                  attrs: {
                                    href: _vm.element.file[0].url,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.element.file_name) +
                                      " "
                                  ),
                                  _c("i", { staticClass: "fad fa-download" })
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ])
                  ]),
                  _vm._v(" "),
                  _c("buttons", {
                    attrs: { isLoading: _vm.isLoading },
                    on: {
                      delete: function($event) {
                        return _vm.deleteItem(_vm.element.id)
                      },
                      edit: function($event) {
                        _vm.isEdit = true
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isEdit
            ? _c("buero-form", {
                attrs: {
                  elementValues: this.element,
                  schema: _vm.schema,
                  method: "patch",
                  url: "/api/merchant/regional-services"
                },
                on: { cancel: _vm.cancelEdit, updateItem: _vm.updateItem }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }